// Shared line-art icons used in MobileBottomNav and ServicePage badges
export const WindowIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="4" y="4" width="16" height="16" rx="1" />
    <line x1="12" y1="4" x2="12" y2="20" />
    <line x1="4" y1="12" x2="20" y2="12" />
  </svg>
);

export const RoofIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3 16 L12 5 L21 16" />
  </svg>
);

export const PaversIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="5" y="4" width="14" height="4.5" rx="0.6" />
    <rect x="5" y="9.75" width="14" height="4.5" rx="0.6" />
    <rect x="5" y="15.5" width="14" height="4.5" rx="0.6" />
  </svg>
);

export const MenuLines = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <line x1="5" y1="8" x2="19" y2="8" />
    <line x1="5" y1="12" x2="19" y2="12" />
    <line x1="5" y1="16" x2="19" y2="16" />
  </svg>
);

export const HouseIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3 11 L12 4 L21 11 L21 20 L3 20 Z" />
    <path d="M10 20 L10 14 L14 14 L14 20" />
  </svg>
);

export const SolarIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M4 19 L7 6 L20 6 L17 19 Z" />
    <line x1="6" y1="11" x2="19" y2="11" />
    <line x1="5" y1="15" x2="18" y2="15" />
    <line x1="11" y1="6" x2="9" y2="19" />
    <line x1="15" y1="6" x2="13" y2="19" />
  </svg>
);
